import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=0acef9ac"
import script from "./questions.vue?vue&type=script&lang=js"
export * from "./questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports